import React from "react";
import GaugeCard from "./GaugeCard";

const cardConfig = [
  {
    title: "Deals",
    value: 120,
    total: 300,
    color: "#19c5c2",
    stats: [
      { label: "Deals Created", value: 120 },
      { label: "Deals Converted", value: 112 },
      { label: "Deals Lost", value: 15 },
    ],
  },
  {
    title: "Accounts",
    value: 120,
    total: 300,
    color: "#165DFF",
    stats: [
      { label: "Accounts Created", value: 120 },
      { label: "Accounts Converted", value: 112 },
      { label: "Accounts Lost", value: 15 },
    ],
  },
  {
    title: "Contacts",
    value: 120,
    total: 300,
    color: "#ff8a00",
    stats: [
      { label: "Contacts Created", value: 120 },
      { label: "Contacts Converted", value: 112 },
      { label: "Contacts Lost", value: 15 },
    ],
  },
];

const DashboardStats: React.FC = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch">
      {cardConfig.map((item, index) => (
        <GaugeCard key={index} {...item} />
      ))}
    </div>
  );
};

export default DashboardStats;
